if (!window.InkArtworkUpload) {
  ((window.InkArtworkUpload = class {
    constructor(root) {
      ((this.root = root),
        (this.input = root.querySelector("[data-upload-input]")),
        (this.shapeInput = root.querySelector("[data-upload-shape-input]")),
        (this.dropzone = root.querySelector("[data-upload-dropzone]")),
        (this.empty = root.querySelector("[data-upload-empty]")),
        (this.fileView = root.querySelector("[data-upload-file]")),
        (this.fileName = root.querySelector("[data-upload-file-name]")),
        (this.fileMeta = root.querySelector("[data-upload-file-meta]")),
        (this.shapeMeta = root.querySelector("[data-upload-shape-meta]")),
        (this.imagePreview = root.querySelector("[data-upload-image-preview]")),
        (this.fileIcon = root.querySelector("[data-upload-file-icon]")),
        (this.editButton = root.querySelector("[data-upload-edit]")),
        (this.removeButton = root.querySelector("[data-upload-remove]")),
        (this.error = root.querySelector("[data-upload-error]")),
        (this.cloudStatus = root.querySelector("[data-cloud-upload-status]")),
        (this.cloudUploadIdInput = root.querySelector(
          "[data-cloud-upload-id]",
        )),
        (this.cloudVersionIdInput = root.querySelector(
          "[data-cloud-version-id]",
        )),
        (this.cloudArtworkKeyInput = root.querySelector(
          "[data-cloud-artwork-key]",
        )),
        (this.cloudShapeKeyInput = root.querySelector(
          "[data-cloud-shape-key]",
        )),
        (this.shapePropertyInput = root.querySelector("[data-artwork-shape]")),
        (this.form = this.input.form),
        (this.editor = root.querySelector("[data-artwork-editor]")),
        this.editor &&
          this.editor.parentElement !== document.body &&
          document.body.appendChild(this.editor),
        (this.editorPanel = this.editor.querySelector(
          ".ink-artwork-editor__panel",
        )),
        (this.editorStage = this.editor.querySelector("[data-editor-stage]")),
        (this.editorCanvas = this.editor.querySelector("[data-editor-canvas]")),
        (this.editorShapeSize = this.editor.querySelector(
          "[data-editor-shape-size]",
        )),
        (this.editorZoom = this.editor.querySelector("[data-editor-zoom]")),
        (this.editorApply = this.editor.querySelector("[data-editor-apply]")),
        (this.editorOriginal = this.editor.querySelector(
          "[data-editor-original]",
        )),
        (this.editorStatus = this.editor.querySelector("[data-editor-status]")),
        (this.editorSourceSize = this.editor.querySelector(
          "[data-editor-source-size]",
        )),
        (this.editorOutputSize = this.editor.querySelector(
          "[data-editor-output-size]",
        )),
        (this.editorRatioButtons = Array.from(
          this.editor.querySelectorAll("[data-editor-ratio]"),
        )),
        (this.editorSelectedShape = this.editor.querySelector(
          "[data-editor-selected-shape]",
        )),
        (this.editorShapePicker = this.editor.querySelector(
          "[data-editor-shape-picker]",
        )),
        (this.editorShapeTrigger = this.editor.querySelector(
          "[data-editor-shape-trigger]",
        )),
        (this.editorShapeTriggerLabel = this.editor.querySelector(
          "[data-editor-shape-trigger-label]",
        )),
        (this.editorShapeMenu = this.editor.querySelector(
          "[data-editor-shape-menu]",
        )),
        (this.editorShapeOptions = Array.from(
          this.editor.querySelectorAll("[data-editor-shape-option]"),
        )),
        (this.editorCustomTools = this.editor.querySelector(
          "[data-editor-custom-tools]",
        )),
        (this.editorCustomDraw = this.editor.querySelector(
          "[data-editor-custom-draw]",
        )),
        (this.editorCustomClear = this.editor.querySelector(
          "[data-editor-custom-clear]",
        )),
        (this.editorPriceTotal = this.editor.querySelector(
          "[data-editor-price-total]",
        )),
        (this.editorPriceDetail = this.editor.querySelector(
          "[data-editor-price-detail]",
        )),
        (this.maxBytes = Number(root.dataset.maxBytes || 20971520)),
        (this.acceptedExtensions = (root.dataset.acceptedExtensions || "")
          .split(",")
          .map((extension) => extension.trim().toLowerCase())
          .filter(Boolean)),
        (this.cloudEndpoint = (root.dataset.gcsUploadEndpoint || "")
          .trim()
          .replace(/\/+$/, "")),
        (this.claimedCustomerId = (
          root.dataset.shopifyCustomerId || ""
        ).trim()),
        (this.claimedCustomerEmail = this.claimedCustomerId
          ? (root.dataset.shopifyCustomerEmail || "").trim()
          : ""),
        (this.claimedCustomerName = this.claimedCustomerId
          ? (root.dataset.shopifyCustomerName || "").trim()
          : ""),
        (this.shopifyProductId = (root.dataset.shopifyProductId || "").trim()),
        (this.shopifyProductHandle = (
          root.dataset.shopifyProductHandle || ""
        ).trim()),
        (this.shopifyProductTitle = (
          root.dataset.shopifyProductTitle || ""
        ).trim()),
        (this.selectedVariantId = (
          root.dataset.selectedVariantId || ""
        ).trim()),
        (this.fixedPriceCents = Number(root.dataset.fixedPriceCents || 0)),
        (this.fixedQuantity = Number(root.dataset.fixedQuantity || 0)),
        (this.fixedSelections = {
          finish: (root.dataset.fixedFinish || "").trim(),
          size: (root.dataset.fixedSize || "").trim(),
          quantity: (root.dataset.fixedQuantity || "").trim(),
        }),
        (this.sectionId = (root.dataset.sectionId || "").trim()),
        (this.browserSessionId = this.getBrowserSessionId()),
        (this.previewUrl = ""),
        (this.editorImageUrl = ""),
        (this.acceptedFile = null),
        (this.shapedFile = null),
        (this.shapedShape = ""),
        (this.editingFile = null),
        (this.editorImage = null),
        (this.editorRatio = "source"),
        (this.editorShape = "custom"),
        (this.editorRotation = 0),
        (this.editorFlipX = 1),
        (this.editorFlipY = 1),
        (this.editorPanX = 0),
        (this.editorPanY = 0),
        (this.editorShapeScale = 1),
        (this.editorZoomValue = 1),
        (this.editorViewWidth = 0),
        (this.editorViewHeight = 0),
        (this.editorPixelRatio = 1),
        (this.dragState = null),
        (this.editorCustomPath = []),
        (this.editorCustomDrawMode = !1),
        (this.editorCustomDrawing = !1),
        (this.selectedVariant = null),
        (this.variantSelections = {}),
        (this.cloudUploadVersion = 0),
        (this.cloudUploadState = this.cloudEndpoint ? "idle" : "disabled"),
        this.bindVariantIdentity(),
        this.bindEvents(),
        this.bindVariantPricing(),
        this.removeDuplicateDealAssurances(),
        this.syncVariantPrice(),
        (this.root.dataset.uploadReady = "true"));
      if (window.InkArtworkAccount && root.dataset.accountEndpoint) this.account = new window.InkArtworkAccount(this);
    }
    isUploadOnly() {
      return (
        this.root.dataset.uploadOnly === "true" &&
        this.shopifyProductHandle === "1000-2-gloss-custom-vinyl-roll-labels"
      );
    }
    bindVariantIdentity() {
      if (!this.form || !this.selectedVariantId) return;
      const variantInput = this.form.querySelector('input[name="id"]');
      (variantInput &&
        !variantInput.value &&
        (variantInput.value = this.selectedVariantId),
        this.form.addEventListener("formdata", (event) => {
          event.formData.get("id") ||
            event.formData.set("id", this.selectedVariantId);
        }));
    }
    removeDuplicateDealAssurances() {
      if (
        !new Set([
          "100-2-gloss-custom-vinyl-stickers",
          "200-3-matte-custom-vinyl-stickers",
          "200-3-matte-custom-vinyl-sticker",
          "100-3-gloss-custom-vinyl-stickers",
          "500-2-gloss-custom-vinyl-stickers",
          "1000-2-gloss-custom-vinyl-roll-labels",
          "50-6-gloss-custom-vinyl-stickers",
          "vinyl-stickers",
          "custom-iridescent-holographic-stickers-vibrant-vinyl-printing",
          "custom-clear-vinyl-stickers-transparent-background-premium-quality",
          "custom-glitter-holographic-stickers-sparkle-with-impact",
          "custom-gold-metallic-stickers-premium-shine-for-your-brand",
          "custom-silver-metallic-stickers-sleek-mirror-like-shine",
          "outdoor-stickers",
          "outdoor-stickers-variant-pricing-test",
          "brand-organization-stickers",
          "retail-stickers",
          "artist-illustrator-stickers",
          "laptop-stickers",
          "vote-group-stickers",
          "helmet-stickers",
          "party-festival-stickers",
          "skateboard-stickers",
          "phone-stickers",
          "bicycle-stickers",
          "credit-card-sticker",
          "sports-club-stickers",
          "snow-board-stickers",
          "band-music-stickers",
          "custom-box-packaging-stickers",
          "water-bottle-stickers",
          "bumper-stickers",
          "landscape-stickers",
          "motorcycle-stickers",
          "pet-cat-stickers",
          "pet-dog-stickers",
          "qr-code-stickers",
          "sign-guide-stickers",
          "surfboard-stickers",
          "tip-stickers",
        ]).has(this.shopifyProductHandle) &&
        !this.shopifyProductHandle.startsWith("qa-material-variant-")
      )
        return;
      const productInfo = this.root.closest(".product-info");
      (productInfo?.querySelector(".x-block-estimate-delivery")?.remove(),
        productInfo?.querySelector(".ip-checkout-confidence")?.remove());
    }
    initArtworkAnalytics() {
      ((this.artworkAnalyticsEdit = null),
        (this.artworkAnalyticsImageVersion = 0),
        this.input.addEventListener("click", () =>
          this.emitArtworkAnalytics("artwork_upload_start", {
            input_method: "picker",
          }),
        ),
        this.dropzone.addEventListener(
          "drop",
          (event) => {
            event.dataTransfer?.files?.length &&
              this.emitArtworkAnalytics("artwork_upload_start", {
                input_method: "drop",
              });
          },
          !0,
        ));
      const activity = () => this.tickArtworkAnalytics(!0);
      ["pointerdown", "pointermove", "keydown", "input", "wheel"].forEach(
        (name) => this.editor.addEventListener(name, activity, { passive: !0 }),
      );
      const visibility = () => this.tickArtworkAnalytics(!1);
      (document.addEventListener("visibilitychange", visibility),
        window.addEventListener("focus", visibility),
        window.addEventListener("blur", visibility),
        window.addEventListener("pagehide", () =>
          this.finishArtworkAnalytics("page_exit"),
        ));
    }
    artworkAnalyticsFile(file) {
      return {
        product_id: String(this.shopifyProductId || ""),
        variant_id: String(
          this.input.form?.querySelector('input[name="id"]')?.value ||
            this.selectedVariantId ||
            "",
        ),
        file_type: file ? this.getExtension(file.name) : "",
        file_size_bucket: file
          ? file.size < 5e6
            ? "under_5mb"
            : file.size <= 20971520
              ? "5_to_20mb"
              : "over_20mb"
          : "",
      };
    }
    emitArtworkAnalytics(name, params = {}, file = null) {
      try {
        const publish = window.Shopify?.analytics?.publish;
        if (typeof publish != "function") return;
        const result = publish.call(
          window.Shopify.analytics,
          "inkelligent:" + name,
          { ...this.artworkAnalyticsFile(file), ...params },
        );
        result?.catch && result.catch(() => {});
      } catch {}
    }
    beginArtworkAnalytics(file) {
      this.finishArtworkAnalytics("replaced");
      const now = performance.now();
      ((this.artworkAnalyticsEdit = {
        last: now,
        activeUntil: now + 3e4,
        duration: 0,
        active: 0,
        visible: !document.hidden && document.hasFocus(),
        pending: !1,
        context: this.artworkAnalyticsFile(file),
      }),
        this.emitArtworkAnalytics(
          "artwork_edit_start",
          this.artworkAnalyticsEdit.context,
        ));
    }
    tickArtworkAnalytics(activity = !1) {
      const edit = this.artworkAnalyticsEdit;
      if (!edit) return;
      const now = performance.now();
      edit.visible &&
        !edit.pending &&
        ((edit.duration += Math.max(0, now - edit.last)),
        (edit.active += Math.max(
          0,
          Math.min(now, edit.activeUntil) - edit.last,
        )));
      const visible = !document.hidden && document.hasFocus();
      (visible &&
        !edit.pending &&
        (activity || !edit.visible) &&
        (edit.activeUntil = now + 3e4),
        (edit.last = now),
        (edit.visible = visible));
    }
    pauseArtworkAnalytics() {
      (this.tickArtworkAnalytics(),
        this.artworkAnalyticsEdit && (this.artworkAnalyticsEdit.pending = !0));
    }
    resumeArtworkAnalytics() {
      (this.tickArtworkAnalytics(),
        this.artworkAnalyticsEdit &&
          ((this.artworkAnalyticsEdit.pending = !1),
          (this.artworkAnalyticsEdit.activeUntil = performance.now() + 3e4)));
    }
    finishArtworkAnalytics(result) {
      this.tickArtworkAnalytics();
      const edit = this.artworkAnalyticsEdit;
      edit &&
        ((this.artworkAnalyticsEdit = null),
        this.emitArtworkAnalytics("artwork_edit_end", {
          ...edit.context,
          edit_result: result,
          edit_duration_seconds: Math.round(edit.duration) / 1e3,
          edit_active_seconds: Math.round(edit.active) / 1e3,
        }));
    }
    bindEvents() {
      (this.initArtworkAnalytics(),
        ["dragenter", "dragover"].forEach((eventName) => {
          this.dropzone.addEventListener(eventName, (event) => {
            (event.preventDefault(),
              this.dropzone.classList.add("is-dragging"));
          });
        }),
        ["dragleave", "dragend"].forEach((eventName) => {
          this.dropzone.addEventListener(eventName, () => {
            this.dropzone.classList.remove("is-dragging");
          });
        }),
        this.dropzone.addEventListener("drop", (event) => {
          (event.preventDefault(),
            this.dropzone.classList.remove("is-dragging"));
          const file = event.dataTransfer && event.dataTransfer.files[0];
          file && (this.replaceInputFile(file), this.setFile(file));
        }),
        this.editButton.addEventListener("click", (event) => {
          (event.preventDefault(),
            event.stopPropagation(),
            this.acceptedFile &&
              this.isEditableImage(this.acceptedFile) &&
              this.openEditor(this.acceptedFile));
        }),
        this.removeButton.addEventListener("click", (event) => {
          (event.preventDefault(),
            event.stopPropagation(),
            this.reset(),
            this.input.focus());
        }),
        this.editor
          .querySelectorAll("[data-editor-close]")
          .forEach((button) => {
            button.addEventListener("click", () => this.closeEditor());
          }),
        this.editorOriginal.addEventListener("click", () => this.useOriginal()),
        this.editorApply.addEventListener("click", () => this.applyEdits()),
        this.editorShapeTrigger.addEventListener("click", () => {
          this.setEditorShapeMenu(this.editorShapeMenu.hidden);
        }),
        this.editorShapeOptions.forEach((option) => {
          option.addEventListener("click", () => {
            (this.selectEditorShape(option.dataset.editorShapeOption),
              this.setEditorShapeMenu(!1),
              this.editorShapeTrigger.focus());
          });
        }),
        this.editorCustomDraw?.addEventListener("click", () => {
          this.setCustomDrawMode(!this.editorCustomDrawMode);
        }),
        this.editorCustomClear?.addEventListener("click", () => {
          ((this.editorCustomPath = []),
            this.setCustomDrawMode(!1),
            this.updateCustomShapeTools(),
            this.drawEditor());
        }),
        this.editorPanel.addEventListener("click", (event) => {
          this.editorShapePicker.contains(event.target) ||
            this.setEditorShapeMenu(!1);
        }),
        this.editorShapePicker.addEventListener("keydown", (event) => {
          event.key === "Escape" &&
            (this.setEditorShapeMenu(!1), this.editorShapeTrigger.focus());
        }),
        this.editorZoom.addEventListener("input", () => {
          this.setEditorZoom(this.editorZoom.value);
        }),
        this.editorShapeSize.addEventListener("input", () => {
          this.setEditorShapeScale(this.editorShapeSize.value);
        }),
        this.editor
          .querySelectorAll("[data-editor-shape-size-step]")
          .forEach((button) => {
            button.addEventListener("click", () => {
              this.setEditorShapeScale(
                this.editorShapeScale +
                  Number(button.dataset.editorShapeSizeStep || 0),
              );
            });
          }),
        this.editor
          .querySelectorAll("[data-editor-zoom-step]")
          .forEach((button) => {
            button.addEventListener("click", () => {
              this.setEditorZoom(
                this.editorZoomValue +
                  Number(button.dataset.editorZoomStep || 0),
              );
            });
          }),
        this.editor
          .querySelectorAll("[data-editor-action]")
          .forEach((button) => {
            button.addEventListener("click", () =>
              this.runEditorAction(button.dataset.editorAction),
            );
          }),
        this.editorCanvas.addEventListener("pointerdown", (event) => {
          if (this.editorImage) {
            if (this.editorShape === "custom" && this.editorCustomDrawMode) {
              ((this.editorCustomPath = [this.getCustomPathPoint(event)]),
                (this.editorCustomDrawing = !0),
                this.editorCanvas.setPointerCapture(event.pointerId),
                this.updateCustomShapeTools(),
                this.drawEditor());
              return;
            }
            ((this.dragState = {
              x: event.clientX,
              y: event.clientY,
              panX: this.editorPanX,
              panY: this.editorPanY,
            }),
              this.editorCanvas.classList.add("is-dragging"),
              this.editorCanvas.setPointerCapture(event.pointerId));
          }
        }),
        this.editorCanvas.addEventListener("pointermove", (event) => {
          if (this.editorCustomDrawing) {
            const point = this.getCustomPathPoint(event),
              previous =
                this.editorCustomPath[this.editorCustomPath.length - 1];
            (!previous ||
              Math.hypot(point.x - previous.x, point.y - previous.y) >=
                0.006) &&
              (this.editorCustomPath.push(point), this.drawEditor());
            return;
          }
          this.dragState &&
            ((this.editorPanX =
              this.dragState.panX + event.clientX - this.dragState.x),
            (this.editorPanY =
              this.dragState.panY + event.clientY - this.dragState.y),
            this.clampEditorPan(),
            this.drawEditor());
        }),
        ["pointerup", "pointercancel"].forEach((eventName) => {
          this.editorCanvas.addEventListener(eventName, () => {
            (this.editorCustomDrawing &&
              ((this.editorCustomDrawing = !1),
              this.editorCustomPath.length < 3 && (this.editorCustomPath = []),
              this.setCustomDrawMode(!1),
              this.updateCustomShapeTools(),
              this.editorShape === "custom" &&
                this.editorCustomPath.length >= 3 &&
                (this.editorStatus.textContent =
                  "Outline ready. Drag the image to reposition it, or choose Redraw outline."),
              this.drawEditor()),
              (this.dragState = null),
              this.editorCanvas.classList.remove("is-dragging"));
          });
        }),
        this.editorCanvas.addEventListener(
          "wheel",
          (event) => {
            (event.preventDefault(),
              this.setEditorZoom(
                this.editorZoomValue + (event.deltaY > 0 ? -0.08 : 0.08),
              ));
          },
          { passive: !1 },
        ),
        window.addEventListener("resize", () => {
          !this.editor.hidden && this.editorImage && this.resizeEditorCanvas();
        }),
        this.form &&
          (this.form.addEventListener(
            "click",
            (event) => {
              event.target.closest(
                'button[type="submit"], input[type="submit"]',
              ) &&
                !this.hasValidFile() &&
                this.blockSubmission(event);
            },
            !0,
          ),
          this.form.addEventListener(
            "submit",
            (event) => {
              this.hasValidFile() || this.blockSubmission(event);
            },
            !0,
          )));
    }
    setEditorShapeMenu(open) {
      ((this.editorShapeMenu.hidden = !open),
        this.editorShapeTrigger.setAttribute("aria-expanded", String(open)),
        open &&
          this.editorShapeOptions
            .find((option) => option.getAttribute("aria-selected") === "true")
            ?.focus());
    }
    setCustomDrawMode(active) {
      ((this.editorCustomDrawMode = !!(
        active && this.editorShape === "custom"
      )),
        this.editorCustomDraw &&
          (this.editorCustomDraw.setAttribute(
            "aria-pressed",
            String(this.editorCustomDrawMode),
          ),
          (this.editorCustomDraw.textContent = this.editorCustomDrawMode
            ? "Drawing\u2026"
            : this.editorCustomPath.length >= 3
              ? "Redraw outline"
              : "Draw outline")),
        this.editorCanvas.classList.toggle(
          "is-drawing",
          this.editorCustomDrawMode,
        ));
      const hint = this.editor.querySelector(".ink-artwork-editor__drag-hint");
      hint &&
        (hint.textContent = this.editorCustomDrawMode
          ? "Draw one continuous outline, then release"
          : "Drag the image to reposition");
    }
    setEditorZoom(value) {
      const min = Number(this.editorZoom.min) || 0.25,
        max = Number(this.editorZoom.max) || 3;
      ((this.editorZoomValue = this.clampNumber(Number(value) || 1, min, max)),
        (this.editorZoom.value = String(this.editorZoomValue)),
        this.clampEditorPan(),
        this.drawEditor());
    }
    setEditorShapeScale(value) {
      const min = Number(this.editorShapeSize.min) || 0.25,
        max = Number(this.editorShapeSize.max) || 1;
      ((this.editorShapeScale = this.clampNumber(Number(value) || 1, min, max)),
        (this.editorShapeSize.value = String(this.editorShapeScale)),
        this.drawEditor());
    }
    updateCustomShapeTools() {
      const isCustom = this.editorShape === "custom";
      (this.editorCustomTools && (this.editorCustomTools.hidden = !isCustom),
        this.editorCustomClear &&
          (this.editorCustomClear.disabled = this.editorCustomPath.length < 3),
        isCustom || this.setCustomDrawMode(!1));
    }
    getCustomPathPoint(event) {
      const bounds = this.editorCanvas.getBoundingClientRect();
      return {
        x: this.clampNumber(
          (event.clientX - bounds.left) / Math.max(1, bounds.width),
          0,
          1,
        ),
        y: this.clampNumber(
          (event.clientY - bounds.top) / Math.max(1, bounds.height),
          0,
          1,
        ),
      };
    }
    bindVariantPricing() {
      this.bindDisplayedArtworkPrice();
      this.sectionId &&
        (document.addEventListener(
          `eurus:product-page-variant-select:updated:${this.sectionId}`,
          () => window.setTimeout(() => this.syncVariantPrice(), 0),
        ),
        document.addEventListener("ink:deal-pricing:updated", (event) => {
          String(event.detail?.sectionId) === String(this.sectionId) &&
            ((this.selectedVariant = event.detail.variant || null),
            (this.variantSelections = event.detail.options || {}),
            this.syncVariantPrice());
        }),
        document.addEventListener("ink:price-change", (event) => {
          const calculator = event.target?.closest?.(
            "[data-ink-native-calculator]",
          );
          if (!calculator || !calculator.contains(this.root) || !event.detail)
            return;
          const allowedShapes = new Set(
            Array.from(
              calculator.querySelectorAll('[data-calcname="Select Shape"]'),
            ).map((input) => this.normalizeShape(input.value)),
          );
          this.editorShapeOptions.forEach((option) => {
            const allowed = allowedShapes.has(
              this.normalizeShape(option.dataset.editorShapeOption),
            );
            ((option.hidden = !allowed), (option.disabled = !allowed));
          });
          const selectedShape = this.normalizeShape(
            event.detail.selection?.shape || event.detail.shape,
          );
          ((this.editorShape = selectedShape),
            this.shapePropertyInput &&
              (this.shapePropertyInput.value = selectedShape),
            this.updateEditorShapeUi(),
            (this.selectedVariant = event.detail.variant || null),
            (this.fixedPriceCents = Math.round(
              Number(event.detail.total || 0) * 100,
            )),
            (this.variantSelections = {
              size: event.detail.selection?.size || event.detail.size || "",
              finish:
                event.detail.selection?.finish || event.detail.finish || "",
              quantity:
                event.detail.selection?.quantity || event.detail.quantity || "",
            }),
            this.syncVariantPrice());
        }));
    }
    getArtworkPriceScope() {
      return this.root.closest(".product-info") || this.form || this.root;
    }
    getArtworkCalculator() {
      return (
        this.root.closest("[data-ink-native-calculator]") ||
        this.getArtworkPriceScope().querySelector("#calculator[data-calcid]")
      );
    }
    readArtworkCalculatorSelections() {
      const calculator = this.getArtworkCalculator();
      if (!calculator) return {};
      const read = (name) => {
        const inputs = Array.from(
          calculator.querySelectorAll("[data-calcname]"),
        ).filter((input) => input.dataset.calcname === name && !input.disabled);
        const selected = inputs.find((input) =>
          input.matches(
            'select, input[type="number"], input[type="text"], input:checked',
          ),
        );
        return selected?.value || "";
      };
      let quantity = read("Select Quantity");
      if (/custom/i.test(quantity)) quantity = read("custom quantity");
      return {
        finish: read("Select Finish"),
        size: read("Select Size"),
        quantity,
        customWidth: read("Select Size").toLowerCase().includes("custom")
          ? read("Width")
          : "",
        customLength: read("Select Size").toLowerCase().includes("custom")
          ? read("Length")
          : "",
      };
    }
    bindDisplayedArtworkPrice() {
      const scope = this.getArtworkPriceScope();
      // The third-party calculator is inserted asynchronously outside the product form.
      // Observe its displayed result, rather than copying its pricing formula.
      let queued = false;
      const sync = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          if (!this.root.isConnected) {
            this.artworkPriceObserver?.disconnect();
            return;
          }
          this.syncVariantPrice();
        });
      };
      scope.addEventListener("change", sync);
      scope.addEventListener("input", sync);
      this.artworkPriceObserver = new MutationObserver(sync);
      this.artworkPriceObserver.observe(scope, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ["data-origmoney", "value", "checked"],
      });
    }
    getSelectedVariant() {
      const source = this.getArtworkPriceScope().querySelector(
        '[data-ink-native-variant-picker] script[type="application/json"][data-selected-variant]',
      );
      let rendered = null;
      try {
        rendered = source?.textContent ? JSON.parse(source.textContent) : null;
      } catch (_) {}
      const id = this.input.form?.querySelector('input[name="id"]')?.value;
      if (rendered && String(rendered.id) === String(id)) return rendered;
      return this.selectedVariant || rendered;
    }
    getVariantSelections() {
      const selections = { ...this.fixedSelections, ...this.variantSelections };
      const scope = this.getArtworkPriceScope();
      scope
        .querySelectorAll("[data-ink-native-variant-picker] [data-option-name]")
        .forEach((container) => {
          const selected = container.querySelector("input:checked, select");
          if (container.dataset.optionName && selected)
            selections[container.dataset.optionName] = selected.value;
        });
      const fixedFinish = scope.querySelector(
        '[data-ink-fixed-finish] input[name="properties[Finish]"]:checked',
      );
      if (fixedFinish) selections.finish = fixedFinish.value;
      for (const [key, value] of Object.entries(
        this.readArtworkCalculatorSelections(),
      )) {
        if (value) selections[key] = value;
      }
      // These two newer fixed packs have no quantity attribute in the shared snippet.
      const fixedPackQuantities = {
        "2000-2-5-gloss-custom-vinyl-roll-labels": 2000,
        "300-2-5-custom-holographic-stickers": 300,
      };
      if (
        !selections.quantity &&
        fixedPackQuantities[this.shopifyProductHandle]
      ) {
        selections.quantity = String(
          fixedPackQuantities[this.shopifyProductHandle],
        );
      }
      return selections;
    }
    getArtworkPriceSummary() {
      const selections = this.getVariantSelections();
      const variant = this.getSelectedVariant();
      const calculator = this.getArtworkCalculator();
      const ticker = calculator?.querySelector("#priceTicker");
      let priceCents = Number(variant?.price ?? this.fixedPriceCents ?? 0);
      let ready = Number.isFinite(priceCents) && priceCents >= 0;
      if (calculator) {
        const text = ticker?.textContent?.trim() || "";
        const numeric = text.replace(/[^\d.\-]/g, "");
        const displayed =
          numeric && /^\d+(?:\.\d+)?$/.test(numeric) ? Number(numeric) : NaN;
        ready = Number.isFinite(displayed);
        priceCents = ready ? Math.round(displayed * 100) : 0;
      }
      const parsedQuantity = Number(
        String(
          selections.quantity || variant?.option3 || this.fixedQuantity || "",
        ).replace(/,/g, ""),
      );
      const quantity =
        Number.isFinite(parsedQuantity) && parsedQuantity > 0
          ? parsedQuantity
          : null;
      const displayedUnit = calculator
        ?.querySelector("[data-summary-unit]")
        ?.textContent?.trim();
      return { priceCents, quantity, ready, displayedUnit, selections };
    }
    syncVariantPrice() {
      const summary = this.getArtworkPriceSummary();
      if (this.editorPriceTotal)
        this.editorPriceTotal.textContent = summary.ready
          ? `$${(summary.priceCents / 100).toFixed(2)}`
          : "Calculating…";
      if (this.editorPriceDetail) {
        const unit = summary.quantity
          ? summary.priceCents / 100 / summary.quantity
          : 0;
        const unitText =
          summary.displayedUnit ||
          `$${unit.toFixed(summary.quantity >= 1000 ? 4 : 2).replace(/(\.\d{2})0+$/, "$1")} each`;
        this.editorPriceDetail.textContent =
          summary.ready && summary.quantity
            ? `${summary.quantity} pcs · ${unitText}`
            : "";
      }
    }
    clampNumber(value, minimum, maximum) {
      const number = Number(value);
      return Number.isFinite(number)
        ? Math.min(maximum, Math.max(minimum, number))
        : minimum;
    }
    setFile(file) {
      if (!file) {
        this.reset();
        return;
      }
      (this.finishArtworkAnalytics("replaced"),
        this.emitArtworkAnalytics("artwork_file_chosen", {}, file));
      const error = this.validateFile(file);
      if (error) {
        (this.emitArtworkAnalytics(
          "artwork_upload_error",
          {
            error_stage: "validation",
            error_type: this.acceptedExtensions.includes(
              this.getExtension(file.name),
            )
              ? "file_too_large"
              : "unsupported_type",
          },
          file,
        ),
          this.reject(error));
        return;
      }
      this.isEditableImage(file) && !this.isUploadOnly()
        ? this.openEditor(file)
        : this.acceptFile(file);
    }
    validateFile(file) {
      const extension = this.getExtension(file.name);
      return this.acceptedExtensions.includes(extension)
        ? file.size > this.maxBytes
          ? `This file is ${this.formatBytes(file.size)}. The maximum file size is ${this.formatBytes(this.maxBytes)}.`
          : ""
        : `This file type is not supported. Upload ${this.acceptedExtensions.map((value) => value.toUpperCase()).join(", ")}.`;
    }
    isEditableImage(file) {
      return (
        ["png", "jpg", "jpeg", "webp"].includes(this.getExtension(file.name)) &&
        /^image\/(png|jpe?g|webp)$/i.test(file.type)
      );
    }
    acceptFile(file, shapePreviewFile = null) {
      const error = this.validateFile(file);
      if (error) {
        this.reject(error);
        return;
      }
      ((this.acceptedFile = file),
        this.replaceInputFile(file),
        this.setShapePreviewFile(shapePreviewFile),
        this.clearError(),
        (this.fileName.textContent = file.name),
        (this.fileMeta.textContent = `${this.getExtension(file.name).toUpperCase()} \xB7 ${this.formatBytes(file.size)}`),
        (this.empty.hidden = !0),
        (this.fileView.hidden = !1),
        (this.editButton.hidden =
          this.isUploadOnly() || !this.isEditableImage(file)),
        this.clearPreview());
      const displayFile = shapePreviewFile || file;
      (this.isEditableImage(displayFile)
        ? ((this.previewUrl = URL.createObjectURL(displayFile)),
          (this.imagePreview.src = this.previewUrl),
          (this.imagePreview.alt = shapePreviewFile
            ? `Shape preview of ${file.name}`
            : `Preview of ${file.name}`),
          (this.fileIcon.hidden = !0))
        : (this.imagePreview.removeAttribute("src"),
          (this.imagePreview.alt = ""),
          (this.fileIcon.hidden = !1)),
        this.startCloudUpload(file, shapePreviewFile));
    }
    startCloudUpload(file, shapePreviewFile) {
      this.account?.reset();
      const version = ++this.cloudUploadVersion;
      if ((this.clearCloudUploadFields(), !this.cloudEndpoint)) {
        ((this.cloudUploadState = "disabled"),
          this.setCloudStatus("", "disabled"));
        return;
      }
      const uploadStarted = performance.now(),
        uploadContext = this.artworkAnalyticsFile(file);
      this.emitArtworkAnalytics("artwork_upload_transfer_start", uploadContext);
      const identity = {
        artworkId: this.createUuid(),
        versionId: this.createUuid(),
      };
      ((this.cloudUploadIdInput.value = identity.artworkId),
        this.cloudVersionIdInput &&
          (this.cloudVersionIdInput.value = identity.versionId),
        (this.cloudUploadState = "uploading"),
        this.setCloudStatus("Uploading\u2026", "uploading"),
        this.uploadFilesToCloud(file, shapePreviewFile, version, identity)
          .then((result) => {
            if (version !== this.cloudUploadVersion) return;
            const artwork = result.uploads.find(
                (upload) => upload.kind === "artwork",
              ),
              shape = result.uploads.find(
                (upload) => upload.kind === "shape-preview",
              );
            ((this.cloudUploadIdInput.value =
              result.artworkId || result.uploadId),
              this.cloudVersionIdInput &&
                (this.cloudVersionIdInput.value = result.versionId || ""),
              (this.cloudArtworkKeyInput.value = artwork
                ? artwork.objectKey
                : ""),
              (this.cloudShapeKeyInput.value = shape ? shape.objectKey : ""),
              (this.cloudUploadState = "ready"),
              this.setCloudStatus("Upload successful", "ready"),
              this.account?.uploaded(result),
              this.emitArtworkAnalytics("artwork_upload_success", {
                ...uploadContext,
                upload_duration_seconds:
                  Math.round(performance.now() - uploadStarted) / 1e3,
              }));
          })
          .catch((error) => {
            version === this.cloudUploadVersion &&
              ((this.cloudUploadState = "error"),
              this.setCloudStatus("Upload failed", "error"),
              this.emitArtworkAnalytics("artwork_upload_error", {
                ...uploadContext,
                error_stage: "upload",
                error_type: "cloud_upload_failed",
                upload_duration_seconds:
                  Math.round(performance.now() - uploadStarted) / 1e3,
              }),
              console.warn("Artwork cloud upload failed:", error));
          }));
    }
    async uploadFilesToCloud(file, shapePreviewFile, uploadVersion, identity) {
      const files = [
          { kind: "artwork", file },
          ...(shapePreviewFile
            ? [{ kind: "shape-preview", file: shapePreviewFile }]
            : []),
        ],
        signResponse = await fetch(`${this.cloudEndpoint}/v1/uploads/sign`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            artworkId: identity.artworkId,
            versionId: identity.versionId,
            sessionId: this.browserSessionId,
            customerId: this.claimedCustomerId,
            customerEmail: this.claimedCustomerEmail,
            customerName: this.claimedCustomerName,
            context: this.getCloudContext(),
            files: files.map((entry) => ({
              kind: entry.kind,
              name: entry.file.name,
              size: entry.file.size,
              contentType: entry.file.type || "application/octet-stream",
            })),
          }),
        }),
        signed = await signResponse.json().catch(() => ({}));
      if (!signResponse.ok)
        throw new Error(
          signed.error || "The secure upload could not be prepared.",
        );
      if (
        !Array.isArray(signed.uploads) ||
        files.some(
          (entry) =>
            !signed.uploads.some((upload) => upload.kind === entry.kind),
        )
      )
        throw new Error("The secure upload response was incomplete.");
      if (uploadVersion !== this.cloudUploadVersion)
        throw new Error(
          "This artwork upload was replaced by a newer selection.",
        );
      if (
        (signed.artworkId || signed.uploadId) !== identity.artworkId ||
        signed.versionId !== identity.versionId
      )
        throw new Error("The secure upload identity did not match.");
      ((this.cloudUploadIdInput.value = signed.artworkId || signed.uploadId),
        this.cloudVersionIdInput &&
          (this.cloudVersionIdInput.value = signed.versionId || ""));
      const signedArtwork = signed.uploads.find(
          (upload) => upload.kind === "artwork",
        ),
        signedShape = signed.uploads.find(
          (upload) => upload.kind === "shape-preview",
        );
      ((this.cloudArtworkKeyInput.value = signedArtwork
        ? signedArtwork.objectKey
        : ""),
        (this.cloudShapeKeyInput.value = signedShape
          ? signedShape.objectKey
          : ""),
        await Promise.all(
          signed.uploads.map(async (upload) => {
            const source = files.find((entry) => entry.kind === upload.kind);
            if (!source)
              throw new Error("The secure upload response was incomplete.");
            const body = new FormData();
            if (
              (Object.entries(upload.fields).forEach(([key, value]) =>
                body.append(key, value),
              ),
              body.append("file", source.file),
              !(await fetch(upload.url, { method: "POST", body })).ok)
            )
              throw new Error(
                `The ${upload.kind === "artwork" ? "artwork" : "shape preview"} cloud upload failed.`,
              );
          }),
        ));
      const completeResponse = await fetch(
          `${this.cloudEndpoint}/v1/uploads/complete`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              artworkId: signed.artworkId || signed.uploadId,
              versionId: signed.versionId,
              completionToken: signed.completionToken,
              context: this.getCloudContext(),
              editorRecipe: this.getEditorRecipe(),
            }),
          },
        ),
        completed = await completeResponse.json().catch(() => ({}));
      if (!completeResponse.ok)
        throw new Error(
          completed.error || "The secure upload could not be recorded.",
        );
      return { ...signed, ...completed };
    }
    getBrowserSessionId() {
      const storageKey = "inkelligent_artwork_session_id";
      try {
        const saved = window.localStorage.getItem(storageKey);
        if (saved && /^[A-Za-z0-9:_-]{16,160}$/.test(saved)) return saved;
        const created =
          window.crypto?.randomUUID?.() ||
          `guest_${Date.now()}_${Math.random().toString(36).slice(2, 14)}`;
        return (window.localStorage.setItem(storageKey, created), created);
      } catch {
        return (
          window.crypto?.randomUUID?.() ||
          `guest_${Date.now()}_${Math.random().toString(36).slice(2, 14)}`
        );
      }
    }
    createUuid() {
      return window.crypto?.randomUUID
        ? window.crypto.randomUUID()
        : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
            /[xy]/g,
            (character) => {
              const random = Math.floor(Math.random() * 16);
              return (character === "x" ? random : (random & 3) | 8).toString(
                16,
              );
            },
          );
    }
    getCloudContext() {
      const variantSelections = this.getVariantSelections(),
        selectedVariant = this.getSelectedVariant(),
        variantId =
          this.input.form?.querySelector('input[name="id"]')?.value ||
          this.selectedVariantId ||
          "",
        priceCents = this.getArtworkPriceSummary().priceCents,
        calculatedPrice = priceCents ? (priceCents / 100).toFixed(2) : "",
        currency = window.Shopify?.currency?.active || "";
      return {
        productId: this.shopifyProductId,
        productHandle: this.shopifyProductHandle,
        productTitle: this.shopifyProductTitle,
        variantId,
        selectedShape: this.editorShape || "custom",
        selectedFinish: variantSelections.finish || "",
        selectedSize: variantSelections.size || "",
        selectedQuantity: variantSelections.quantity || "",
        customWidth: variantSelections.customWidth || "",
        customLength: variantSelections.customLength || "",
        calculatedPrice,
        currency,
      };
    }
    getEditorRecipe() {
      return {
        shape: this.editorShape,
        ratio: this.editorRatio,
        rotation: this.editorRotation,
        flipX: this.editorFlipX,
        flipY: this.editorFlipY,
        panX: this.editorPanX,
        panY: this.editorPanY,
        shapeScale: this.editorShapeScale,
        zoom: this.editorZoomValue,
        customPath: this.editorCustomPath.map((point) => ({
          x: point.x,
          y: point.y,
        })),
      };
    }
    clearCloudUploadFields() {
      ((this.cloudUploadIdInput.value = ""),
        this.cloudVersionIdInput && (this.cloudVersionIdInput.value = ""),
        (this.cloudArtworkKeyInput.value = ""),
        (this.cloudShapeKeyInput.value = ""));
    }
    setCloudStatus(message, state) {
      ((this.cloudStatus.textContent = message),
        (this.cloudStatus.dataset.state = state),
        (this.cloudStatus.hidden = !message));
    }
    openEditor(file) {
      (this.finishArtworkAnalytics("replaced"),
        this.artworkAnalyticsImageVersion++,
        this.syncVariantPrice(),
        file !== this.acceptedFile &&
          ((this.editorCustomPath = []), this.setCustomDrawMode(!1)),
        (this.editingFile = file),
        (this.editorStatus.textContent = "Loading image\u2026"),
        (this.editorApply.disabled = !0),
        (this.editorOriginal.disabled = !1),
        (this.editor.hidden = !1),
        document.body.classList.add("ink-artwork-editor-open"),
        this.editorImageUrl && URL.revokeObjectURL(this.editorImageUrl),
        (this.editorImageUrl = URL.createObjectURL(file)));
      const image = new Image(),
        analyticsImageVersion = this.artworkAnalyticsImageVersion;
      ((image.onload = () => {
        analyticsImageVersion !== this.artworkAnalyticsImageVersion ||
          this.editor.hidden ||
          ((this.editorImage = image),
          this.syncSelectedShape(),
          (this.editorRatio = this.getShapeDefaultRatio()),
          (this.editorRotation = 0),
          (this.editorFlipX = 1),
          (this.editorFlipY = 1),
          (this.editorPanX = 0),
          (this.editorPanY = 0),
          (this.editorShapeScale = 1),
          (this.editorShapeSize.value = "1"),
          (this.editorZoomValue = 1),
          (this.editorZoom.value = "1"),
          this.editorRatioButtons.forEach((button) => {
            button.setAttribute(
              "aria-pressed",
              String(button.dataset.editorRatio === this.editorRatio),
            );
          }),
          (this.editorSourceSize.textContent = `Source: ${image.naturalWidth} \xD7 ${image.naturalHeight}px \xB7 ${this.formatBytes(file.size)}`),
          (this.editorStatus.textContent = ""),
          (this.editorApply.disabled = !1),
          this.resizeEditorCanvas(),
          this.setCustomDrawMode(!1),
          this.editorPanel.querySelector("[data-editor-close]").focus(),
          this.beginArtworkAnalytics(file));
      }),
        (image.onerror = () => {
          analyticsImageVersion !== this.artworkAnalyticsImageVersion ||
            this.editor.hidden ||
            (this.emitArtworkAnalytics(
              "artwork_edit_error",
              { error_stage: "decode", error_type: "image_decode_failed" },
              file,
            ),
            (this.editorStatus.textContent =
              "This image could not be opened. You can upload the original file instead."),
            (this.editorApply.disabled = !0));
        }),
        (image.src = this.editorImageUrl));
    }
    syncSelectedShape() {
      const rawValue =
        this.shapePropertyInput?.value || this.editorShape || "Custom";
      ((this.editorShape = this.normalizeShape(rawValue)),
        this.shapePropertyInput &&
          (this.shapePropertyInput.value = this.editorShape),
        this.updateEditorShapeUi());
    }
    normalizeShape(value) {
      const normalized = String(value || "Custom")
          .trim()
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/^-|-$/g, ""),
        aliases = {
          "custom-shape": "custom",
          "custom-cut": "custom",
          "pen-outline": "custom",
          love: "heart",
          "love-heart": "heart",
          "rounded-square": "round-square",
          "rounded-rectangle": "round-rectangle",
        },
        supported = [
          "custom",
          "heart",
          "circle",
          "square",
          "oval",
          "round-square",
          "round-rectangle",
          "rectangle",
        ],
        shape = aliases[normalized] || normalized;
      return supported.includes(shape) ? shape : "custom";
    }
    updateEditorShapeUi() {
      this.editorSelectedShape.dataset.shape = this.editorShape;
      const selected = this.editorShapeOptions.find(
        (option) => option.dataset.editorShapeOption === this.editorShape,
      );
      ((this.editorShapeTriggerLabel.textContent =
        selected?.textContent.trim() || "Custom"),
        this.editorShapeOptions.forEach((option) => {
          option.setAttribute(
            "aria-selected",
            String(option.dataset.editorShapeOption === this.editorShape),
          );
        }),
        this.updateCustomShapeTools());
    }
    selectEditorShape(shape) {
      const nextShape = this.normalizeShape(shape);
      ((this.editorShape = nextShape),
        this.shapePropertyInput &&
          (this.shapePropertyInput.value = this.editorShape));
      const calculator = this.root.closest("[data-ink-native-calculator]"),
        calculatorShape = Array.from(
          calculator?.querySelectorAll('[data-calcname="Select Shape"]') || [],
        ).find((input) => this.normalizeShape(input.value) === nextShape);
      (calculatorShape &&
        !calculatorShape.checked &&
        ((calculatorShape.checked = !0),
        calculatorShape.dispatchEvent(new Event("change", { bubbles: !0 }))),
        (this.editorShapeScale = 1),
        (this.editorShapeSize.value = "1"),
        this.updateEditorShapeUi(),
        (this.editorRatio = this.getShapeDefaultRatio()),
        this.editorRatioButtons.forEach((button) => {
          button.setAttribute(
            "aria-pressed",
            String(button.dataset.editorRatio === this.editorRatio),
          );
        }),
        (this.editorPanX = 0),
        (this.editorPanY = 0),
        this.resizeEditorCanvas(),
        this.setCustomDrawMode(!1),
        (this.editorStatus.textContent =
          nextShape === "custom"
            ? "Drag the image to reposition it."
            : "Drag the image to position it inside the selected shape."));
    }
    getShapeDefaultRatio() {
      return ["heart", "circle", "square", "round-square"].includes(
        this.editorShape,
      )
        ? "1"
        : ["oval", "rectangle", "round-rectangle"].includes(this.editorShape)
          ? "1.5"
          : "source";
    }
    closeEditor() {
      (this.finishArtworkAnalytics("cancelled"),
        this.artworkAnalyticsImageVersion++,
        (this.editor.hidden = !0),
        document.body.classList.remove("ink-artwork-editor-open"),
        (this.editorStatus.textContent = ""),
        (this.dragState = null),
        this.editorImageUrl &&
          (URL.revokeObjectURL(this.editorImageUrl),
          (this.editorImageUrl = "")),
        this.acceptedFile
          ? this.replaceInputFile(this.acceptedFile)
          : (this.input.value = ""),
        (this.editingFile = null));
    }
    resizeEditorCanvas() {
      if (!this.editorImage) return;
      const availableWidth = Math.max(
          240,
          Math.min(620, this.editorStage.clientWidth - 52),
        ),
        maxHeight = window.innerWidth < 768 ? 292 : 420,
        ratio = this.getEditorRatio();
      let width = availableWidth,
        height = width / ratio;
      (height > maxHeight && ((height = maxHeight), (width = height * ratio)),
        (this.editorViewWidth = Math.max(1, width)),
        (this.editorViewHeight = Math.max(1, height)),
        (this.editorPixelRatio = Math.min(window.devicePixelRatio || 1, 2)),
        (this.editorCanvas.width = Math.round(
          this.editorViewWidth * this.editorPixelRatio,
        )),
        (this.editorCanvas.height = Math.round(
          this.editorViewHeight * this.editorPixelRatio,
        )),
        (this.editorCanvas.style.width = `${this.editorViewWidth}px`),
        (this.editorCanvas.style.height = `${this.editorViewHeight}px`),
        this.clampEditorPan(),
        this.drawEditor());
    }
    getEditorRatio() {
      return this.editorRatio === "source"
        ? Math.abs(this.editorRotation % 180) === 90
          ? this.editorImage.naturalHeight / this.editorImage.naturalWidth
          : this.editorImage.naturalWidth / this.editorImage.naturalHeight
        : Number(this.editorRatio);
    }
    getRotatedDimensions() {
      const rotationSwapsSides = Math.abs(this.editorRotation % 180) === 90;
      return {
        width: rotationSwapsSides
          ? this.editorImage.naturalHeight
          : this.editorImage.naturalWidth,
        height: rotationSwapsSides
          ? this.editorImage.naturalWidth
          : this.editorImage.naturalHeight,
      };
    }
    getEditorScale() {
      const rotated = this.getRotatedDimensions();
      return (
        Math.max(
          this.editorViewWidth / rotated.width,
          this.editorViewHeight / rotated.height,
        ) * this.editorZoomValue
      );
    }
    clampEditorPan() {
      if (!this.editorImage || !this.editorViewWidth || !this.editorViewHeight)
        return;
      const rotated = this.getRotatedDimensions(),
        scale = this.getEditorScale(),
        maxX = Math.abs(rotated.width * scale - this.editorViewWidth) / 2,
        maxY = Math.abs(rotated.height * scale - this.editorViewHeight) / 2;
      ((this.editorPanX = Math.min(maxX, Math.max(-maxX, this.editorPanX))),
        (this.editorPanY = Math.min(maxY, Math.max(-maxY, this.editorPanY))));
    }
    drawEditor() {
      if (!this.editorImage) return;
      const context = this.editorCanvas.getContext("2d"),
        scale = this.getEditorScale(),
        radians = (this.editorRotation * Math.PI) / 180;
      (context.setTransform(
        this.editorPixelRatio,
        0,
        0,
        this.editorPixelRatio,
        0,
        0,
      ),
        context.clearRect(0, 0, this.editorViewWidth, this.editorViewHeight),
        context.save(),
        context.translate(
          this.editorViewWidth / 2 + this.editorPanX,
          this.editorViewHeight / 2 + this.editorPanY,
        ),
        context.rotate(radians),
        context.scale(scale * this.editorFlipX, scale * this.editorFlipY),
        context.drawImage(
          this.editorImage,
          -this.editorImage.naturalWidth / 2,
          -this.editorImage.naturalHeight / 2,
        ),
        context.restore(),
        this.drawShapeGuide(context),
        this.updateEditorOutputSize());
    }
    drawShapeGuide(context) {
      const width = this.editorViewWidth,
        height = this.editorViewHeight,
        inset = Math.max(7, Math.min(width, height) * 0.025),
        maskedShapes = [
          "heart",
          "circle",
          "oval",
          "square",
          "rectangle",
          "round-square",
          "round-rectangle",
        ],
        customMask =
          this.editorShape === "custom" && this.editorCustomPath.length >= 3;
      if (
        (context.save(), maskedShapes.includes(this.editorShape) || customMask)
      ) {
        if (
          (context.beginPath(),
          context.rect(0, 0, width, height),
          !this.addShapePath(context, inset))
        ) {
          context.restore();
          return;
        }
        ((context.fillStyle = "rgba(8, 20, 18, .48)"), context.fill("evenodd"));
      }
      if ((context.beginPath(), !this.addShapePath(context, inset))) {
        context.restore();
        return;
      }
      ((context.lineWidth = 4),
        (context.strokeStyle = "rgba(255, 255, 255, .94)"),
        context.stroke(),
        context.setLineDash([8, 6]),
        (context.lineWidth = 2),
        (context.strokeStyle = "#0f6b59"),
        context.stroke(),
        context.restore());
    }
    addShapePath(
      context,
      inset,
      width = this.editorViewWidth,
      height = this.editorViewHeight,
    ) {
      const shapeScale = this.clampNumber(this.editorShapeScale, 0.25, 1),
        availableWidth = Math.max(1, width - inset * 2),
        availableHeight = Math.max(1, height - inset * 2),
        pathWidth = Math.max(1, availableWidth * shapeScale),
        pathHeight = Math.max(1, availableHeight * shapeScale),
        left = (width - pathWidth) / 2,
        top = (height - pathHeight) / 2;
      if (this.editorShape === "circle") {
        const radius = Math.max(1, Math.min(pathWidth, pathHeight) / 2);
        return (context.arc(width / 2, height / 2, radius, 0, Math.PI * 2), !0);
      }
      if (this.editorShape === "heart") {
        const centerX = left + pathWidth / 2,
          right = left + pathWidth,
          bottom = top + pathHeight;
        return (
          context.moveTo(centerX, top + pathHeight * 0.24),
          context.bezierCurveTo(
            centerX - pathWidth * 0.08,
            top,
            left,
            top + pathHeight * 0.03,
            left,
            top + pathHeight * 0.3,
          ),
          context.bezierCurveTo(
            left,
            top + pathHeight * 0.56,
            centerX - pathWidth * 0.13,
            top + pathHeight * 0.77,
            centerX,
            bottom,
          ),
          context.bezierCurveTo(
            centerX + pathWidth * 0.13,
            top + pathHeight * 0.77,
            right,
            top + pathHeight * 0.56,
            right,
            top + pathHeight * 0.3,
          ),
          context.bezierCurveTo(
            right,
            top + pathHeight * 0.03,
            centerX + pathWidth * 0.08,
            top,
            centerX,
            top + pathHeight * 0.24,
          ),
          context.closePath(),
          !0
        );
      }
      if (this.editorShape === "oval")
        return (
          context.ellipse(
            width / 2,
            height / 2,
            pathWidth / 2,
            pathHeight / 2,
            0,
            0,
            Math.PI * 2,
          ),
          !0
        );
      if (["round-square", "round-rectangle"].includes(this.editorShape)) {
        const radius = Math.min(pathWidth, pathHeight) * 0.16;
        return (
          context.roundRect(left, top, pathWidth, pathHeight, radius),
          !0
        );
      }
      return this.editorShape === "custom"
        ? this.editorCustomPath.length
          ? (this.editorCustomPath.forEach((point, index) => {
              const pointX =
                  width / 2 + (width * point.x - width / 2) * shapeScale,
                pointY =
                  height / 2 + (height * point.y - height / 2) * shapeScale;
              index === 0
                ? context.moveTo(pointX, pointY)
                : context.lineTo(pointX, pointY);
            }),
            this.editorCustomPath.length >= 3 && context.closePath(),
            !0)
          : !1
        : (context.rect(left, top, pathWidth, pathHeight), !0);
    }
    updateEditorOutputSize() {
      if (!this.editorImage) return;
      const exportScale = 1 / this.getEditorScale(),
        dimensions = this.limitOutputDimensions(
          Math.round(this.editorViewWidth * exportScale),
          Math.round(this.editorViewHeight * exportScale),
        );
      this.editorOutputSize.textContent = `Output: ${dimensions.width} \xD7 ${dimensions.height}px`;
    }
    limitOutputDimensions(width, height) {
      const largest = Math.max(width, height);
      if (largest <= 6e3)
        return { width: Math.max(1, width), height: Math.max(1, height) };
      const multiplier = 6e3 / largest;
      return {
        width: Math.max(1, Math.round(width * multiplier)),
        height: Math.max(1, Math.round(height * multiplier)),
      };
    }
    runEditorAction(action) {
      this.editorImage &&
        (action === "rotate-left" &&
          (this.editorRotation = (this.editorRotation - 90) % 360),
        action === "rotate-right" &&
          (this.editorRotation = (this.editorRotation + 90) % 360),
        action === "flip-x" && (this.editorFlipX *= -1),
        action === "flip-y" && (this.editorFlipY *= -1),
        action === "reset" &&
          (this.syncSelectedShape(),
          (this.editorRatio = this.getShapeDefaultRatio()),
          (this.editorRotation = 0),
          (this.editorFlipX = 1),
          (this.editorFlipY = 1),
          (this.editorShapeScale = 1),
          (this.editorShapeSize.value = "1"),
          (this.editorZoomValue = 1),
          (this.editorZoom.value = "1"),
          (this.editorCustomPath = []),
          this.setCustomDrawMode(!1),
          this.updateCustomShapeTools(),
          this.editorRatioButtons.forEach((button) => {
            button.setAttribute(
              "aria-pressed",
              String(button.dataset.editorRatio === this.editorRatio),
            );
          })),
        (this.editorPanX = 0),
        (this.editorPanY = 0),
        this.resizeEditorCanvas());
    }
    createOutputCanvas() {
      const displayScale = this.getEditorScale(),
        dimensions = this.limitOutputDimensions(
          Math.round(this.editorViewWidth / displayScale),
          Math.round(this.editorViewHeight / displayScale),
        ),
        exportScale = dimensions.width / this.editorViewWidth,
        outputCanvas = document.createElement("canvas");
      ((outputCanvas.width = dimensions.width),
        (outputCanvas.height = dimensions.height));
      const context = outputCanvas.getContext("2d"),
        radians = (this.editorRotation * Math.PI) / 180;
      return (
        context.translate(
          dimensions.width / 2 + this.editorPanX * exportScale,
          dimensions.height / 2 + this.editorPanY * exportScale,
        ),
        context.rotate(radians),
        context.scale(
          displayScale * exportScale * this.editorFlipX,
          displayScale * exportScale * this.editorFlipY,
        ),
        context.drawImage(
          this.editorImage,
          -this.editorImage.naturalWidth / 2,
          -this.editorImage.naturalHeight / 2,
        ),
        outputCanvas
      );
    }
    async createShapePreviewFile(sourceCanvas, baseName) {
      const scale = Math.min(
          1,
          1600 / Math.max(sourceCanvas.width, sourceCanvas.height),
        ),
        width = Math.max(1, Math.round(sourceCanvas.width * scale)),
        height = Math.max(1, Math.round(sourceCanvas.height * scale)),
        previewCanvas = document.createElement("canvas");
      ((previewCanvas.width = width), (previewCanvas.height = height));
      const context = previewCanvas.getContext("2d");
      (context.save(),
        context.beginPath(),
        this.addShapePath(context, 0, width, height) && context.clip(),
        context.drawImage(sourceCanvas, 0, 0, width, height),
        context.restore());
      const blob = await this.canvasToBlob(previewCanvas, "image/png");
      if (!blob) throw new Error("The shape preview could not be exported.");
      if (blob.size > this.maxBytes)
        throw new Error(
          `The shape preview is ${this.formatBytes(blob.size)}. Please use a smaller image.`,
        );
      return new File([blob], `${baseName}-shape-${this.editorShape}.png`, {
        type: "image/png",
        lastModified: Date.now(),
      });
    }
    async useOriginal() {
      if (!this.editorImage || !this.editingFile) {
        this.editorStatus.textContent =
          "The editor session expired. Close the editor and choose the artwork again.";
        return;
      }
      (this.pauseArtworkAnalytics(),
        (this.editorOriginal.disabled = !0),
        (this.editorApply.disabled = !0),
        (this.editorStatus.textContent =
          "Preparing artwork and shape preview\u2026"));
      try {
        ((this.editorRatio = this.getShapeDefaultRatio()),
          (this.editorRotation = 0),
          (this.editorFlipX = 1),
          (this.editorFlipY = 1),
          (this.editorPanX = 0),
          (this.editorPanY = 0),
          (this.editorShapeScale = 1),
          (this.editorShapeSize.value = "1"),
          (this.editorZoomValue = 1),
          (this.editorZoom.value = "1"),
          this.resizeEditorCanvas());
        const outputCanvas = this.createOutputCanvas(),
          baseName = this.editingFile.name.replace(/\.[^.]+$/, "") || "artwork",
          shapePreviewFile = await this.createShapePreviewFile(
            outputCanvas,
            baseName,
          );
        (this.finishArtworkAnalytics("original"),
          this.acceptFile(this.editingFile, shapePreviewFile),
          this.closeEditor());
      } catch (error) {
        (this.resumeArtworkAnalytics(),
          this.emitArtworkAnalytics(
            "artwork_edit_error",
            { error_stage: "export", error_type: "shape_export_failed" },
            this.editingFile,
          ),
          (this.editorStatus.textContent =
            error.message || "The shape preview could not be exported."),
          (this.editorOriginal.disabled = !1),
          (this.editorApply.disabled = !1));
      }
    }
    async applyEdits() {
      if (!this.editorImage || !this.editingFile) {
        this.editorStatus.textContent =
          "The editor session expired. Close the editor and choose the artwork again.";
        return;
      }
      (this.pauseArtworkAnalytics(),
        (this.editorApply.disabled = !0),
        (this.editorStatus.textContent =
          "Preparing high-resolution artwork\u2026"));
      try {
        const outputCanvas = this.createOutputCanvas(),
          originalExtension = this.getExtension(this.editingFile.name),
          outputType =
            this.editorZoomValue < 1
              ? "image/png"
              : ["jpg", "jpeg"].includes(originalExtension)
                ? "image/jpeg"
                : originalExtension === "webp"
                  ? "image/webp"
                  : "image/png",
          outputExtension =
            outputType === "image/jpeg"
              ? "jpg"
              : outputType === "image/webp"
                ? "webp"
                : "png",
          blob = await this.canvasToBlob(outputCanvas, outputType, 0.94);
        if (!blob) throw new Error("Image export failed.");
        if (blob.size > this.maxBytes)
          throw new Error(
            `The edited image is ${this.formatBytes(blob.size)}. Reduce the crop size or zoom in so it is under ${this.formatBytes(this.maxBytes)}.`,
          );
        const baseName =
            this.editingFile.name.replace(/\.[^.]+$/, "") || "artwork",
          shapePreviewFile = await this.createShapePreviewFile(
            outputCanvas,
            baseName,
          ),
          editedFile = new File(
            [blob],
            `${baseName}-edited.${outputExtension}`,
            { type: outputType, lastModified: Date.now() },
          );
        (this.finishArtworkAnalytics("completed"),
          this.acceptFile(editedFile, shapePreviewFile),
          this.closeEditor());
      } catch (error) {
        (this.resumeArtworkAnalytics(),
          this.emitArtworkAnalytics(
            "artwork_edit_error",
            { error_stage: "export", error_type: "image_export_failed" },
            this.editingFile,
          ),
          (this.editorStatus.textContent =
            error.message || "The image could not be exported."),
          (this.editorApply.disabled = !1));
      }
    }
    canvasToBlob(canvas, type, quality) {
      return new Promise((resolve) => canvas.toBlob(resolve, type, quality));
    }
    replaceInputFile(file) {
      const transfer = new DataTransfer();
      (transfer.items.add(file), (this.input.files = transfer.files));
    }
    setShapePreviewFile(file) {
      if (
        ((this.shapedFile = file || null),
        (this.shapedShape = file ? this.editorShape : ""),
        (this.shapeInput.value = ""),
        !file)
      ) {
        ((this.shapeMeta.textContent = ""), (this.shapeMeta.hidden = !0));
        return;
      }
      const transfer = new DataTransfer();
      (transfer.items.add(file),
        (this.shapeInput.files = transfer.files),
        (this.shapeMeta.textContent = "Shape preview ready"),
        (this.shapeMeta.hidden = !1));
    }
    reject(message) {
      ((this.input.value = ""),
        (this.acceptedFile = null),
        this.setShapePreviewFile(null),
        this.clearPreview(),
        (this.empty.hidden = !1),
        (this.fileView.hidden = !0),
        this.showError(message));
    }
    reset() {
      this.account?.reset();
      (this.finishArtworkAnalytics("cancelled"),
        this.artworkAnalyticsImageVersion++,
        (this.cloudUploadVersion += 1),
        (this.cloudUploadState = this.cloudEndpoint ? "idle" : "disabled"),
        this.clearCloudUploadFields(),
        this.setCloudStatus("", this.cloudUploadState),
        (this.input.value = ""),
        (this.acceptedFile = null),
        this.setShapePreviewFile(null),
        (this.editingFile = null),
        (this.editorCustomPath = []),
        this.setCustomDrawMode(!1),
        this.clearPreview(),
        (this.empty.hidden = !1),
        (this.fileView.hidden = !0),
        (this.editButton.hidden = !0),
        this.clearError());
    }
    hasValidFile() {
      const file = this.input.files && this.input.files[0];
      return !(
        !file ||
        file.size === 0 ||
        this.validateFile(file) ||
        (this.editingFile && this.editingFile !== this.acceptedFile) ||
        (!this.isUploadOnly() &&
          this.isEditableImage(file) &&
          !(this.shapeInput.files && this.shapeInput.files[0])) ||
        (this.cloudEndpoint && (
          this.cloudUploadState !== "ready" ||
          !this.cloudUploadIdInput?.value?.trim() ||
          !this.cloudVersionIdInput?.value?.trim() ||
          !this.cloudArtworkKeyInput?.value?.trim() ||
          (this.shapeInput.files?.[0] && !this.cloudShapeKeyInput?.value?.trim())
        ))
      );
    }
    blockSubmission(event) {
      (event?.preventDefault(), event?.stopImmediatePropagation());
      const file = this.input.files && this.input.files[0];
      let message =
        "Please upload your artwork before adding this item to your cart.";
      (file && (file.size === 0 || this.validateFile(file))
        ? (message = this.validateFile(file) || "This artwork file is empty. Please choose another file.")
        : file &&
      !this.isUploadOnly() &&
      this.isEditableImage(file) &&
      !(this.shapeInput.files && this.shapeInput.files[0])
        ? (message =
            "Please confirm the selected shape in the editor before adding this item to your cart.")
        : file && this.cloudUploadState === "uploading"
          ? (message =
              "Your artwork is still uploading. Please wait a moment and try again.")
          : file &&
            this.cloudUploadState === "error" &&
            (message =
              "Your artwork could not be saved. Please upload the file again."),
        this.showError(message),
        this.root.scrollIntoView({ behavior: "smooth", block: "center" }));
    }
    showError(message) {
      ((this.error.textContent = message),
        (this.error.hidden = !1),
        this.dropzone.classList.add("has-error"),
        this.input.classList.add("required-picker"));
    }
    clearError() {
      ((this.error.hidden = !0),
        this.dropzone.classList.remove("has-error"),
        this.input.classList.remove("required-picker"));
    }
    clearPreview() {
      this.previewUrl &&
        (URL.revokeObjectURL(this.previewUrl), (this.previewUrl = ""));
    }
    getExtension(fileName) {
      const pieces = fileName.toLowerCase().split(".");
      return pieces.length > 1 ? pieces.pop() : "";
    }
    formatBytes(bytes) {
      if (bytes === 0) return "0 B";
      const units = ["B", "KB", "MB", "GB"],
        index = Math.min(
          Math.floor(Math.log(bytes) / Math.log(1024)),
          units.length - 1,
        ),
        value = bytes / 1024 ** index;
      return `${value >= 10 || index === 0 ? value.toFixed(0) : value.toFixed(1)} ${units[index]}`;
    }
  }),
    (window.initInkArtworkUploads = (scope = document) => {
      const roots = [];
      (scope.matches &&
        scope.matches("[data-ink-artwork-upload]") &&
        roots.push(scope),
        roots.push(...scope.querySelectorAll("[data-ink-artwork-upload]")),
        roots.forEach((root) => {
          root._inkArtworkUploadInstance ||
            (root.removeAttribute("data-upload-ready"),
            (root._inkArtworkUploadInstance = new window.InkArtworkUpload(
              root,
            )));
        }));
    }));
  const interceptArtworkFileChange = (event) => {
      const input = event.target;
      if (!input.matches || !input.matches("[data-upload-input]")) return;
      const root = input.closest("[data-ink-artwork-upload]");
      root &&
        (root._inkArtworkUploadInstance || window.initInkArtworkUploads(root),
        event.stopImmediatePropagation(),
        root._inkArtworkUploadInstance?.setFile(input.files && input.files[0]));
    },
    interceptArtworkEditorAction = (event) => {
      const button =
        event.target.closest &&
        event.target.closest("[data-editor-apply], [data-editor-original]");
      if (!button) return;
      const root = button.closest("[data-ink-artwork-upload]");
      if (!root) return;
      (root._inkArtworkUploadInstance || window.initInkArtworkUploads(root),
        event.preventDefault(),
        event.stopImmediatePropagation());
      const instance = root._inkArtworkUploadInstance;
      button.matches("[data-editor-original]")
        ? instance?.useOriginal()
        : instance?.applyEdits();
    },
    blockInvalidArtworkUpload = (event) => {
      const button = event.target.closest?.(
        'button[type="submit"], input[type="submit"], [data-native-checkout]'
      );
      const form = button ? button.form : event.target;
      if (form?.tagName === "FORM") window.validateInkArtworkUpload(form, event);
    };

  const uploadRootsForForm = (form) => {
    const roots = new Set(form.querySelectorAll("[data-ink-artwork-upload]"));
    Array.from(form.elements || []).forEach((field) => {
      if (field.matches?.("[data-upload-input]")) {
        const root = field.closest("[data-ink-artwork-upload]");
        if (root) roots.add(root);
      }
    });
    return Array.from(roots);
  };

  window.getInkArtworkForm = (form) => {
    if (!form) return form;
    const id = form.getAttribute("id") || "";
    if (id.startsWith("product-form-sticky-")) {
      const mainForm = document.getElementById(id.replace("product-form-sticky-", "product-form-"));
      if (mainForm && uploadRootsForForm(mainForm).length) return mainForm;
    }
    return form;
  };

  window.validateInkArtworkUpload = (form, event) => {
    form = window.getInkArtworkForm(form);
    if (!form) return false;
    const roots = uploadRootsForForm(form);
    for (const root of roots) {
      const input = root.querySelector("[data-upload-input]");
      if (!input) continue;
      if (!root._inkArtworkUploadInstance) {
        try { window.initInkArtworkUploads(root); } catch (_) {}
      }
      const instance = root._inkArtworkUploadInstance;
      if (!instance || !instance.hasValidFile()) {
        if (instance) instance.blockSubmission(event);
        else {
          event?.preventDefault();
          event?.stopImmediatePropagation();
          const error = root.querySelector("[data-upload-error]");
          if (error) {
            error.textContent = "Please upload your artwork and wait for the upload to finish.";
            error.hidden = false;
          }
          input.classList.add("required-picker");
          root.querySelector("[data-upload-dropzone]")?.classList.add("has-error");
          root.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return false;
      }
      instance.clearError();
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput && !variantInput.value) variantInput.value = root.dataset.selectedVariantId || "";
    }
    return true;
  };
  (window.addEventListener("change", interceptArtworkFileChange, !0),
    window.addEventListener("click", interceptArtworkEditorAction, !0),
    window.addEventListener("click", blockInvalidArtworkUpload, !0),
    window.addEventListener("submit", blockInvalidArtworkUpload, !0),
    document.readyState === "loading"
      ? document.addEventListener("DOMContentLoaded", () =>
          window.initInkArtworkUploads(),
        )
      : window.initInkArtworkUploads(),
    document.addEventListener("shopify:section:load", (event) => {
      window.initInkArtworkUploads(event.target);
    }),
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          node.nodeType === 1 && window.initInkArtworkUploads(node);
        });
      });
    }).observe(document.documentElement, { childList: !0, subtree: !0 }));
}
